module.exports = __webpack_public_path__ + "static/testing.493fadad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/testing.png
// module id = 1713
// module chunks = 67936617089079 213534597649335